// AccordionStyles.ts
import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
`;

export const AccordionItemWrapper = styled.div`
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionTrigger = styled.button<{ $isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  background-color: #f9f9f9;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    background-color: #f1f1f1;
  }

  &::after {
    content: "${(props) => (props.$isOpen ? '−' : '+')}";
    font-size: 1.5rem;
    transition: transform 0.3s ease;
  }
`;

export const AccordionContentWrapper = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  /* Use max-height transition for smooth animation */
  max-height: ${(props) => (props.$isOpen ? 'auto' : '0')}; /* A generous height for transition */
  transition: max-height 0.3s ease-out;
  padding: ${(props) => (props.$isOpen ? '15px' : '0 15px')};
  background-color: #fff;
`;

export const AccordionContentInner = styled.div`
  /* Inner div helps with padding issues during max-height transition */
  padding-top: 0;
`;
